<script setup lang="ts">
import globalFunctions from '@/ts/global-functions.ts';
import { getLangText } from '@/ts/utils/utils.ts';
import SupportIcon from '../assets/side-nav/side-nav-support.svg?raw';
import SideNavLiveChat from '../assets/side-nav/side-nav-live-chat.svg?raw';
</script>

<template>
    <div class="menu-item" @click.prevent.stop="globalFunctions.openChat()">
        <div class="icon" v-html="SupportIcon"></div>
        <a href="#" @click.prevent class="menu-item">{{ getLangText('SupportLabel') }}</a>
        <div class="side-btn">
            <div class="inner">
                <div class="icon" v-html="SideNavLiveChat"></div>
                {{ getLangText('LiveChatLabel') }}
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @use './mobile-nav-side-item.scss';
</style>